const messages = {
  global: {
    tenant: "Locataire|Locataires",
    tenants: "0 locataires|2 locataires|{n} locataires",
    site: "Emplacement|Emplacements",
    sites: "0 emplacements|1 emplacement|{n} emplacements",
    day: "Jour|Jours",
    days: "0 jours|1 jour|{n} jours",
    any: "N'importe lequel",
    or: "ou",
    options: "Option|Options",
    attachments: "Pièces jointes",
    noAttachments: "Aucune pièce jointe",
    error: "Erreur",
    all: "Tous",
    list: "Liste",
    onDate: "le",
    atTime: "à",
    by: "de",
    copy: "copie",
    clone: "clone",
    propertiesShort: "Propriété.",
    role: "Rôle|Rôles",
    assignedRoles: "Rôle attribué|Rôles attribués",
    anonymousUser: "Utilisateur anonyme",
    unset: "Non défini",
    picture: "Image|Images",
  },
  action: {
    ok: "OK",
    apply: "Appliquer",
    confirm: "Confirmer",
    cancel: "Annuler",
    close: "Fermer",
    select: "Sélectionner",
    yes: "Oui",
    no: "Non",
    save: "Enregistrer",
    create: "Créer",
    add: "Ajouter",
    edit: "Modifier",
    complete: "Terminer",
    stopEdit: "Arrêter la modification",
    refresh: "Actualiser",
    clear: "Réinitialiser",
    clearAll: "Supprimer tout",
    remove: "Supprimer",
    upload: "Téléverser",
    download: "Télécharger",
    delete: "Supprimer",
    back: "retour",
    send: "Envoyer",
    search: "Rechercher",
    newEllipsis: "Nouveau...",
    moreEllipsis: "Plus...",
    addEllipsis: "Ajouter...",
    selectEllipsis: "Sélectionner...",
    copyEllipsis: "Copier...",
    cloneEllipsis: "Cloner...",
    captureEllipsis: "Capturer...",
    goto: "Aller à : {nom}",
    loginWithPasskey: "Clé d’accès",
    loginWithMicrosoft: "Se connecter avec Microsoft",
    confirmQuantity: "Confirmer la quantité",
    showBarcode: "Afficher les codes-barres",
    developerMode: "Mode développement",
    showLotVisual: "Visualiser le lot",
    showAuditVisual: "Visualiser l'audit",
    colorModeSystem: "Système",
    colorModeLight: "Clair",
    colorModeDark: "Sombre",
    requestQuantityInput: "manuel",
    scan: "Scanner",
    scanBarcode: "Scanner le code-barres",
    scanItem: "Scanner l'article",
    addToList: "Ajouter à la liste",
    addPasskey: "Ajouter une clé d'accès",
    linkMicrosoftAccount: "Lier un compte Microsoft",
    copyToClipboard: "Copier",
    copyToExtension: "Copier",
    placeOrder: "Passer la commande",
    fillDemands: "Sync. les demandes",
    acceptOrder: "Accepter la commande",
    consumeListed: "Consommer la liste",
    printPreviewEllipsis: "Vue étiquette...",
    printEllipsis: "Imprimer...",
    showPast: "Afficher le passé",
    resendEmail: "Renvoyer l'e-mail",
    ignore: "Ignorer",
    discardAndLeave: "Abandonner et quitter",
    ignoreSignature: "Ignorer la signature (lot / DLC / péremption) et afficher les totaux par article",
    reorder: "Recommander",
    addToDraft: "Ajouter au brouillon",
    addToCart: "Ajouter au panier",
    addToNewOrderEllipsis: "Ajouter à une nouvelle commande...",
    addToOrderDraft: "Ajouter au panier",
    verifyConnection: "Vérifier la connexion",
    ttsRead: "Lire à haute voix",
    asrRecognize: "Reconnaissance vocale",
    viewMail: "Voir l'e-mail",
    viewMailInMyLanguage: "Voir l'e-mail dans ma langue",
    "show-all": "Afficher tout",
    revoke: "Révoquer",
    cancelOrderShort: "Annuler",
    triggeredPageReload: "Rechargement de la page -> {reason}",
    goHome: "Aller à l'accueil",
    undoStockChange: "Annuler le mouvement de stock (dans la mesure du possible)",
  },
  status: {
    none: "",
    pending: "En attente",
    inProgress: "En cours",
    completed: "Terminé",
    succeeded: "Réussi",
    cancelled: "Annulé",
    failed: "Échec",
    orderCancelledShort: "Annulée",
    loadingEllipsis: "Chargement des données...",
    savingEllipsis: "Enregistrement des données...",
  },
  reason: {
    reloadPageForcedByServer: "Forcé du serveur",
    reloadPageNewServerBuild: "Mise à jour du build serveur",
    reloadPageAssetChanged: "Mise à jour des assets",
    partialDelivery: "Livraison partielle",
    partialDeliveryIgnored: "Livraison partielle (ignorée)",
    partialDeliveryReordered: "Livraison partielle (recommandée)",
    partialDeliveryMissingItemsCopiedToDraftOrder: "Livraison partielle (planifiée)",
  },
  enum: {
    restockPullType: {
      "0": "Commande",
      "1": "Min-Max",
      "2": "Bac Min-Max",
    },
  },
  instruction: {
    confirmQuantitySummary: "Confirmez la quantité après le scaning au lieu de publier la quantité directement.",
    showBarcodeSummary: "Afficher les codes-barres des articles en stock et livrés dans les listes.",
    developerModeSummary: "Afficher les informations nécessaires au développement (mode débogage)",
    showLotVisualSummary: "Afficher un indicateur visuel du lot pour distinguer le lot d'un coup d'œil.",
    showAuditVisualSummary: "Afficher les utilisateurs avec un fond coloré pour distinguer les différents utilisateurs d'un coup d'œil.",
    restockPullTypeOriginalPack: "Scanner lorsque le pack est vide",
    provideRequiredFields: "Veuillez renseigner tous les champs obligatoires",
    requiresAtLeaseTwoEntries: "Au moins deux entrées sont requises",
    undoStockChangeConfirm: "Annuler ce mouvement de stock ? Si le stock actuel ne couvre plus la modification d'origine, l'annulation est limitée à la quantité réellement disponible.",
    unsavedChangesTitle: "Modifications non enregistrées",
    unsavedChangesLeaveConfirm: "Des modifications non enregistrées sont en cours. Quitter la page et les abandonner ?",
  },
  help: {
    assignItemsToSupplierWithoutItems: "Modifiez ce fournisseur pour assigner des articles.",
  },
  placeholder: {
    newSupplier: "<Nouveau fournisseur>",
  },
  validation: {
    required: "Ce champ est obligatoire",
    minLength: "Ce champ doit contenir au moins {min} caractères",
    maxLength: "Ce champ doit contenir au maximum {max} caractères",
    codeRequired: "Le code est requis",
    nameRequired: "Le nom est requis",
    emailRequired: "L'adresse e-mail est requise",
    emailMustBeValid: "L'adresse e-mail doit être valide",
    emailType: "L'adresse email doit être valide",
    passwordRequired: "Le mot de passe est requis",
    passwordMinLength: "Le mot de passe doit contenir au moins {min} caractères",
    confirmPasswordRequired: "Une confirmation du mot de passe est requise",
    passwordConfirmMatch: "Les mots de passe doivent correspondre",
    requiredPermissions: "Permissions requises: {permissions}",
    duplicateCodes: "Codes en double : {duplicates}",
  },
  statement: {
    contentCopied: "Contenu copié",
    itemCopied: "Numéro d'article {matériel} copié",
    emailSent: "Un email a été envoyé.",
    supplierSaved: "Fournisseur {supplierCode} enregistré",
    itemBlockSaved: "Ensemble d'articles enregistré",
    orderIsAccepted: "Commande acceptée",
    orderIsCancelled: "Commande annulée",
    receivingIsAccepted: "Réception acceptée",
    foreignItemSaved: "Article PMS enregistré",
    consumptionSaved: "Consommation enregistrée",
    partialDeliveryMissingItemsCopiedToDraftOrder: "Articles manquants copiés dans le brouillon de commande",
    partialDeliveryMissingItemsReordered: "Articles manquants recommandés",
    partialDeliveryIgnored: "Livraison partielle ignorée",
  },
  error: {
    accessDenied: "Accès refusé",
    pageAccessDenied: "Vous n'avez pas accès à cette page",
    copiedError: "Erreur de copie",
    axiosErrorMessage: "{code}: {message}",
    apiError: "Erreur API : {error}",
    noData: "Aucune donnée disponible",
    unknownItem: "Article inconnu",
    noLabelsToPrint: "Aucune étiquette à imprimer",
    nothingToSave: "Rien à enregistrer",
    noCode: "Aucun code",
    noItemGtin: "Pas de GTIN pour l'article #{itemId}",
    noHtmlMailAvailable: "Aucun e-mail HTML disponible",
    failedToLoadHtmlMail: "Échec du chargement de l'e-mail HTML",
    supplierHasNoAssignedItems: "Le fournisseur '{supplierName}' n'a aucun article assigné",
    baseItemNotFoundForItem: "Article de base #{baseItemId} introuvable pour l'article '{itemCode}'",
    itemNotManagedByDemand: "L'article '{itemCode}' n'est pas géré par demande",
    itemManagedByStockLevels: "L'article '{itemCode}' est géré par niveaux de stock",
    noItemSupplierAssigned: "Aucun fournisseur assigné",
    noSupplierFoundForItem: "Aucun fournisseur trouvé pour l'article '{itemCode}'",
    noSupplierItemFoundForItem: "Aucun article fournisseur trouvé pour l'article '{itemCode}' avec le fournisseur #{supplierId}, article fournisseur {{supplierItemId}} ({supplierItemCode})",
    supplierSaveError: "Erreur lors de l'enregistrement du fournisseur : {error}",
    requiresValidSignature: "Suivi de signature requis / signature calculée non autorisée '{itemCode}'",
    notEnoughStockShort: "Pas assez de stock ! Demandé {quantity} {unitName}, disponible {available {unitName}",
    notEnoughStock: "Pas assez de stock pour l'article #{itemId} ({tenantCode}/{itemCode}), demandé {quantity} {unitName}, disponible {available} {unitName}",
    invalidPatientCode: "Numéro de patient invalide : {patientCode}",
  },
  menu: {
    home: "Page d'accueil",
    controlling: "Contrôle",
    masterdata: "Données de base",
    administration: "Administration",
    "manage-users": "Gérer les utilisateurs",
    "manage-tenants": "Gérer les locataires",
    "manage-sites": "Gérer les emplacements",
    tenant: "Locataire",
    site: "l'emplacement",
    items: "Article",
    "item-edit": "Modifier l'article",
    "itemblocks": "Ensembles d'articles",
    "itemblock-create": "Créer un ensemble d'articles",
    "foreign-items": "Articles PMS",
    suppliers: "Fournisseurs",
    "info-request": "Infos",
    "info-device": "Appareil",
    deliveries: "Livraison",
    orders: "Commandes",
    "order-create": "Créer une commande",
    "order-list": "Liste des commandes",
    receivings: "Réception de marchandises",
    consumption: "Consommation",
    "consumption-list": "Liste des consommations",
    stocks: "stock",
    "stock-changes": "modifications de stock",
    "stock-demand": "Besoin de réapprovisionnement",
    "order-demand": "Besoin de commande",
    "stock-receipt": "Accès",
    "stock-issue": "Départ",
    "label-item": "Étiquettes des articles",
    "label-box": "Étiquettes des conteneurs",
    statistics: {
      consumption: "consommation",
      expiry: "expiration",
    },
    "label-printers": "Imprimantes d'étiquettes",
    "label-printer-edit": "Imprimante",
    "label-templates": "Modèles d'étiquettes",
    "label-template-edit": "Modèle d'étiquette",
    "order-confirmation": "Confirmation de commande",
  },
  language: {
    en: "Anglais",
    de: "Allemand",
    fr: "Français",
  },
  field: {
    generic: {
      code: "Code",
      name: "Nom",
      status: "Statut",
      description: "Description",
      general: "Général",
      password: "Mot de passe",
      token: "Jeton",
      rowActions: "",
      id: "ID",
      email: "E-mail",
      quantity: "Quantité",
      item: "Article",
      tradeItem: "GTIN|GTINs",
      supplier: "Fournisseur|Fournisseurs",
      customer: "Client|Clients",
      address: "Adresse",
      phone: "Téléphone",
      created: "Créé",
      updated: "Modifié",
      itemblock: "Ensemble d'articles",
      company: "Entreprise",
      contactName: "Nom du contact",
      order: "Commande|Commandes",
      delivery: "Livraison|Livraisons",
      linesCount: "# positions",
      language: "Langue",
    },
    user: {
      fullName: "Nom complet",
      fullNamePlaceholder: "Prénom Nom",
    },
    emailQueue: {
      statusLabel: "Statut de l'e-mail",
    },
    masterdata: {
      itemCode: "Code article",
      orderUnitCode: "Unité de commande",
      trackStock: "Stock ?",
      lot: "Lot",
      bestBefore: "Date limite d'utilisation",
      expiry: "Date d'expiration",
      patientCode: "N° patient",
    },
    export: {
      exportStatus: "Statut d'export",
      exportReference: "Référence d'export",
      exportResult: "Résultat d'export",
    },
    item: {
      unitName: "Unité",
      restockPullType: "TR",
      allowCalculatedSignature: "ASC",
    },
    tradeItem: {
      unitCode: "Code unité",
      factor: "Facteur",
      defaultUnitCode: "PC",
    },
    foreignItem: {
      itemCode: "N° article PMS",
    },
    itemBlock: {
      code: "Code (QR)",
    },
    supplier: {
      supplierCode: "N° fournisseur",
      supplierCodeTitle: "Code comptes fournisseurs",
      customerCode: "N° client",
      customerCodeTitle: "Code comptes clients",
      assignedSupplier: "Fournisseur assigné",
      assignedItems: "Articles assignés",
      itemCode: "REF",
      cultureName: "Langue de l'e-mail",
      cultureNameTitle: "Langue utilisée pour l'envoi des e-mails de commande à ce fournisseur",
      autoConfirmOrder: "Confirmation automatique de la commande",
      autoConfirmOrderTitle: "La commande de ce fournisseur est confirmée automatiquement sans demander de date de livraison",
      autoOrderEnabled: "Création automatique des commandes",
      autoOrderEnabledTitle: "L'exécution quotidienne de l'auto-commande crée des commandes pour les articles de ce fournisseur. Lorsque désactivé, les besoins restent dans le brouillon pour être commandés manuellement.",
    },
    order: {
      orderedQuantity: "Quantité commandée",
      deliveryDate: "Date de livraison",
    },
    fidoCredential: {
      lastUsedPlatformInfo: "Dernière plateforme utilisée",
    },
    entraLogin: {
      displayName: "Nom d'affichage",
    },
    serviceConnection: {
      endpointURL: "URL du serveur",
    },
    credential: {
      type: "Type d'authentification",
      username: "Nom d'utilisateur",
      password: "Mot de passe",
      authenticatorSecret: "Secret d'authentification",
    },
    receiving: {
      deliveredQuantity: "Quantité livrée",
    },
    consumption: {
      billable: "Facturable",
      billableShort: "Fact.",
      nonBillable: "Non facturable",
      nonBillableShort: "Non fact.",
    },
    pms: {
      mandator: "Mandataire PMS",
    },
  },
  page: {
    home: {
      heading: "Bienvenue chez Melodi",
    },
    login: {
      heading: "Inscription",
      rememberme: "Rester connecté",
      signin: "Connexion",
      forgotPassword: "Mot de passe oublié?",
    },
    "forgot-password": {
      heading: "Mot de passe oublié",
      description: "Entrez votre adresse email et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    },
    "reset-password": {
      heading: "Réinitialiser le mot de passe",
      description: "Veuillez saisir votre nouveau mot de passe.",
      confirmPassword: "Confirmer le mot de passe",
      submit: "Confirmer",
      resetSuccess: "Votre mot de passe a été réinitialisé avec succès.",
      resetError: "Votre mot de passe n'a pas pu être réinitialisé.",
    },
    "accept-invite": {
      heading: "S'inscrire en tant que nouvel utilisateur",
      description: "Veuillez entrer votre nom et votre nouveau mot de passe.",
      confirmPassword: "Confirmer le mot de passe",
      submit: "Confirmer",
      userRegistrationSuccess: "Votre inscription a réussi.",
      userRegistrationError: "Votre inscription a échoué.",
    },
    profile: {
      developer: "Développeur",
      manageThisSettingOnDesktop: "Gérer ce paramètre sur le bureau",
      apiKey: "Clé API",
      passkeys: "Clés d'accès",
      generateApiKey: "Générer la clé API",
      removeApiKey: "Supprimer la clé API",
      generateApiKeyTitle: "Clé API",
      apiKeyReplaceWarning: "La génération d'une nouvelle clé API invalidera l'ancienne.",
      apiKeyShownOnceWarning: "La clé API ne sera affichée qu'une seule fois. Veuillez la sauvegarder avant de quitter la page.",
      apiKeyCreating: "Création d'une clé API...",
      apiKeyCreated: "La clé API a été créée.",
      apiKeyCreateError: "Erreur lors de la création de la clé API : {error}",
      apiKeyDeleting: "La clé API est en cours de suppression...",
      apiKeyDeleted: "La clé API a été supprimée.",
      apiKeyDeleteError: "Erreur lors de la suppression de la clé API : {error}",
      apiKeyCopied: "La clé API a été copiée dans le presse-papiers.",
      apiKeyCopiedError: "Erreur lors de la copie de la clé API dans le presse-papiers.",
      loginToken: "QR de connexion",
      generateLoginToken: "Générer le QR de connexion",
      removeLoginToken: "Supprimer le QR de connexion",
      loginTokenReplaceWarning: "La génération d'un nouveau QR de connexion invalidera le code QR actuel.",
      loginTokenCreating: "Création du QR de connexion...",
      loginTokenCreated: "QR de connexion créé.",
      loginTokenCreateError: "Erreur lors de la création du QR de connexion : {error}",
      loginTokenDeleting: "Suppression du QR de connexion...",
      loginTokenDeleted: "QR de connexion supprimé.",
      loginTokenDeleteError: "Erreur lors de la suppression du QR de connexion : {error}",
      loginTokenCopied: "QR de connexion copié dans le presse-papiers.",
      loginTokenCopiedError: "Erreur lors de la copie du QR de connexion dans le presse-papiers.",
      linkedServicesTitle: "Services liés",
      addLinkedService: "Ajouter un service",
      logout: "Déconnexion",
      verifyingConnection: "Vérification de la connexion...",
      connectionSuccessful: "Connexion vérifiée avec succès",
      connectionFailed: "Échec de la connexion",
      serviceLinkSaved: "Liaison de service enregistrée",
      serviceLinkDeleted: "Liaison de service supprimée",
      invalidServiceConfiguration: "Configuration de service invalide",
      failedToVerifyConnection: "Échec de la vérification de la connexion",
      failedToSave: "Échec de l'enregistrement",
      failedToDelete: "Échec de la suppression",
      entraLogins: "Compte Microsoft",
      noEntraLogins: "Aucun compte Microsoft lié.",
      entraLinkError: "Erreur lors de la liaison du compte Microsoft.",
    },
    entra: {
      processing: "Connexion Microsoft en cours...",
      missingParameters: "Paramètres d'autorisation manquants.",
      invalidState: "État d'autorisation invalide.",
      unknownError: "Une erreur inconnue s'est produite.",
    },
    "manage-tenants": {
      form: {
        title: "Gérer les locataires",
      },
      tenantCreated: "Locataire {name} créé",
      tenantUpdated: "Locataire {name} mis à jour",
      tenantDeleted: "Locataire {name} supprimé",
      siteCreated: "L'emplacement {name} créé",
      siteUpdated: "L'emplacement {name} mis à jour",
      siteDeleted: "L'emplacement {name} supprimé",
    },
    "manage-users": {
      form: {
        title: "Gérer les utilisateurs",
        inviteUser: "Inviter un utilisateur",
      },
      newUserTitle: "Nouvel utilisateur",
      newUserEllipsis: "Nouveau utilisateur...",
      usersList: "Utilisateurs",
      user: "Utilisateur",
      deleteUser: "Supprimer l'utilisateur",
      deleteUserConfirmation: "Êtes-vous sûr de vouloir supprimer cet utilisateur?",
      inviteUserSuccess: "Chargement des utilisateurs suivi",
      inviteUserError: "Erreur lors de l'invitation : {error}",
      selectAtLeastOneRole: "Sélectionnez au moins un rôle!",
      userChangSaveSuccess: "Les modifications de l'utilisateur ont été enregistrées",
      userChangeSaveError: "Erreur lors de l'enregistrement des modifications de l'utilisateur : {error}",
    },
    supplier: {
      deleteConfirmTitle: "Supprimer le fournisseur",
      deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer le fournisseur '{supplierName}' ({supplierCode})?",
    },
    site: {
      title: "Choisissez votre emplacement",
    },
    item: {
      table: {
        description: "Description",
        baseUnitCode: "Code unité de base",
        consumerUnitCode: "Code de l'unité",
        consumerUnitName: "GTIN",
        logisticUnitCode: "code de l'unité logistique",
        logisticUnitName: "PU",
        logisticUnitFactor: "facteur d'unité logistique",
        tracking: "Attributs",
        trackLotNumber: "Lot?",
        trackBestBeforeDate: "Date limite d'utilisation?",
        trackExpirationDate: "Date d'expiration?",
        bestBeforeLeadTime: "Anonncer date limite d'utilisation ",
        expirationLeadTime: "Anonncer date limite d'expiration",
        isBillable: "Facturable?",
        isBillableShort: "FC",
        canOrderManually: "Commande manuelle?",
        requiresLabel: "Étiquette?",
        allowCalculateLot: "Sélectionner le lot automatiquement?",
      },
      form: {
        description: "Description",
        mainImage: "Image du produit",
        sizeImage: "Image de grande taille",
        sizeMiniImage: "Image de petite taille",
        defaultLabelQuantity: "Quantité par défaut",
        defaultLabelTemplate: "Modèle d'étiquette par défaut",
        restockPullType: "Type de reconstitution",
      },
      saved: "Article enregistré",
      saveError: "Erreur lors de l'enregistrement de l'article",
      openOrders: {
        title: "Commandes ouvertes",
        openQuantity: "Ouvert",
        replacementOf: "Remplacement : {code} ({name})",
      },
      draftCart: {
        title: "Dans le panier",
      },
    },
    info: {
      form: {
        title: "Infos",
        barcodeOrItemCode: "Code barre ou numéro d'article",
      },
    },
    device: {
      screen: "Écran",
      displayResolution: "Résolution de l'écran",
      displayViewport: "Vue de l'écran",
      network: "Réseau",
      remoteAddress: "Adresse distante",
      userAgent: "Agent utilisateur",
    },
    stock: {
      successMessage: "Les stocks ont été ajustés",
      errorMessage: "Erreur lors de la mise à jour de l'article : {item}",
      itemSourceAll: "Origine",
      itemSourceMelodi: "Melodi",
      itemSourceExternal: "Externe",
    },
    stockDemand: {
      table: {
        quantityDemand: "Quantité requise",
        quantityOrdered: "Quantité commandée",
        quantityDelivered: "Quantité livrée",
        stockQuantity: "Stock",
        stockHistory: "Historique des stocks",
      },
    },
    stockReceipt: {
      form: {
        title: "Accès",
        confirm: "Réserver l'accès",
      },
      successMessage: "{quantity} {unit} ajouté à l'inventaire",
      errorMessage: "Erreur de réservation d'accès : {error}",
    },
    stockIssue: {
      form: {
        title: "Départ",
        confirm: "Réserver le départ",
      },
      successMessage: "{quantity} {unit} débité de l'inventaire",
      errorMessage: "Erreur de réservation de départ : {error}",
    },
    labelPrint: {
      form: {
        title: "Imprimer",
        confirm: "Imprimer l'étiquette",
      },
      successMessage: "Étiquette envoyée à l'imprimante {printer}",
      noTradeItemDefined: "L'article {itemCode} n'a pas d'article commercial!!",
    },
    labelPrinter: {
      table: {
        address: "Adresse réseau",
      },
      form: {
        address: "Adresse réseau",
        confirm: "Enregistrer l'imprimante",
      },
      saved: "Imprimante enregistrée",
      saveError: "Erreur lors de l'enregistrement",
      deleteError: "Erreur lors de la suppression",
      deleteConfirmTitle: "Supprimer l'imprimante d'étiquettes",
      deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer l'imprimante d'étiquettes '{code}' ?",
      deletedSuccessfully: "Imprimante d'étiquettes '{code}' supprimée avec succès",
    },
    labelTemplate: {
      table: {
        templateContent: "Modèle d'étiquette",
      },
      form: {
        templateContent: "Modèle d'étiquette",
        confirm: "Enregistrer le modèle",
      },
      saved: "Modèle enregistré",
      saveError: "Erreur lors de l'enregistrement",
      deleteError: "Erreur lors de la suppression",
      deleteConfirmTitle: "Supprimer le modèle d'étiquette",
      deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer le modèle d'étiquette '{code}' ?",
      deletedSuccessfully: "Modèle d'étiquette '{code}' supprimé avec succès",
    },
    delivery: {
      form: {
        deliveryCode: "Code du bon de livraison",
        deliveryCodeHelp: "Scannez ou saisissez le code du bon de livraison",
        book: "Livraison du livre",
      },
      list: {
        title: "Livraison",
      },
      notFoundError: "Livraison introuvable",
      deliveryNotFoundError: "Livraison {deliveryCode} introuvable",
      differentSiteWarning: "La livraison est destinée à un endroit différent",
      completeError: "La livraison n'a pas pu être confirmée : {error}",
      completed: "Livraison {deliveryCode} confirmée",
    },
    order: {
      form: {
        orderCode: "Code de commande",
        orderCodeHelp: "Scannez ou saisissez le code de commande",
      },
      notFoundError: "Commande introuvable",
      orderNotFoundError: "Commande {orderCode} introuvable",
      notInProgressError: "La commande {orderCode} n'est pas en cours et ne peut pas être réceptionnée",
      acceptError: "La commande n'a pas pu être confirmée : {error}",
      accepted: "Commande {orderCode} confirmée",
    },
    "order-create": {
      nothingToOrder: "Rien à commander",
      orderSaving: "Sauvegarde de la commande...",
      orderSaved: "Commande enregistrée : {orderCode}",
      ordersSaved: "Commande(s) enregistrée(s)",
      orderSaveError: "Erreur lors de l'enregistrement de la commande : {error}",
      quantitiesConfirmedFor: "{quantity} {unitCode} confirmés pour {date}",
      quantitiesOrderedSince: "{quantity} {unitCode} commandés depuis {date}",
      addedToOrderDraft: "Article ajouté au panier",
      addToOrderDraftError: "Erreur lors de l'ajout de l'article au panier",
      help: {
        title: "Aide de la page",
        topics: {
          placeOrder: {
            title: "Passer la commande",
            description: "Crée une commande par fournisseur à partir des articles du panier et envoie à chaque fournisseur un e-mail de commande dans sa langue configurée. Le panier est ensuite vidé et vous êtes redirigé vers la liste des commandes.",
          },
          fillDemands: {
            title: "Synchroniser les demandes",
            description: "Ajoute au panier les articles gérés en Min/Max avec leur besoin actuel. Les commandes déjà ouvertes sont prises en compte et les quantités sont arrondies à l'unité de commande du fournisseur.",
          },
          autoOrder: {
            title: "Commande automatique quotidienne",
            description: "Chaque jour à 20:00, le système passe automatiquement les commandes pour les articles Min/Max selon le besoin actuel — selon la même logique que « Synchroniser les demandes ». Cela inclut les articles qui sont alors sous leur stock minimum, même s'ils n'ont pas été ajoutés manuellement.",
          },
        },
      },
    },
    consumption: {
      notFoundError: "Consommation introuvable",
      acceptError: "La consommation n'a pas pu être confirmée : {error}",
      accepted: "Consommation {referenceCode} confirmée",
      retryExport: "Exporter la consommation",
      retryingExport: "Nouvelle tentative d'export de consommation...",
      exportSuccess: "Export de consommation {referenceCode} réussi",
      exportRetryError: "Échec de la nouvelle tentative d'export de consommation : {error}",
      cancelExport: "Annuler l'export de consommation",
      exportCancelError: "Échec de l'annulation de l'export de consommation : {error}",
      exportCancelled: "Export de consommation {referenceCode} annulé",
      nonBillableDescription: "Cette consommation n'est pas facturable et diminuera uniquement le stock sans être exportée vers le PMS.",
    },
    "consumption-create": {
      consumptionSaving: "Enregistrement de la consommation...",
    },
    "item-label": {
      captureTitle: "Capturer l'étiquette",
      confirm: "Ajouter une étiquette",
    },
    itemBlock: {
      deleteConfirmTitle: "Supprimer l'ensemble d'articles",
      deleteConfirmMessage: "Êtes-vous sûr de vouloir supprimer l'ensemble d'articles '{itemBlockName}' ({itemBlockCode})?",
      deletedSuccessfully: "Ensemble d'articles '{itemBlockCode}' supprimé avec succès"
    },
    statistics: {
      labels: {
        itemIssues: "Consommation/semaine",
        maxStock: "Stock maximum",
        today: "Aujourd'hui",
      },
    },
  },
};

export default messages;
